/* eslint-disable */
import { useState, useEffect } from "react";
import { InputBox, SubmitButton } from "../../components/Input";
import { Link } from "react-router-dom";
import { API_URL } from "../../config";
import axios from "axios";
import { showToast } from "../../components/toast";
import CompanyHeader from "./CompanyHeader";

const TestNotification = () => {
  const [formData, setFormData] = useState({
    test_subscriber_id: "",
    test_service_id: "",
    test_subscription_id: "",
  });

  const [serviceList, setServiceList] = useState([]);
  const [loading, setLoading] = useState(false);
  const token = localStorage.getItem("authToken");

  // Fetch all services from API
  const fetchServices = async () => {
    try {
      setLoading(true);
      const response = await axios.get(`${API_URL}portfolio/serviceList`, {
        headers: {
          Authorization: `Bearer ${token}`,
          Accept: "*/*",
        },
      });

      if (response.data.success) {
        setServiceList(response.data.data || []);
      } else {
        showToast.error("Failed to fetch services.");
      }
    } catch (error) {
      console.error(error);
      showToast.error("Error fetching services.");
    } finally {
      setLoading(false);
    }
  };

  // Fetch existing configuration to prefill fields
  const fetchConfigurations = async () => {
    try {
      setLoading(true);
      const response = await axios.get(`${API_URL}settings/company/Configurations`, {
        headers: {
          Authorization: `Bearer ${token}`,
          Accept: "*/*",
        },
      });

      if (response.data.success && response.data.data) {
        const config = response.data.data;
        setFormData({
          test_service_id: config.test_service_id || "",
          test_subscriber_id: config.test_subscriber_id || "",
          test_subscription_id: config.test_subscription_id || "",
        });
      } else {
        showToast.error("Failed to fetch existing configuration.");
      }
    } catch (error) {
      console.error(error);
      showToast.error("Error fetching existing configuration.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchServices();
    fetchConfigurations();
  }, []);

  // Handle input change
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  // Handle form submit
  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!formData.test_subscriber_id || !formData.test_service_id) {
      showToast.warning("Please fill all required fields.");
      return;
    }

    try {
      setLoading(true);

      // Convert test_subscriber_id to string exactly as entered (comma separated)
      // Make sure to trim whitespace so id list is clean
      const subscriberIdsString = formData.test_subscriber_id
        .split(",")
        .map((id) => id.trim())
        .filter((id) => id !== "")
        .join(",");

      const response = await axios.post(
        `${API_URL}settings/company/configuration/save?id=1`,
        {
          test_service_id: Number(formData.test_service_id),
          test_subscriber_id: subscriberIdsString, // Send as comma separated string
          test_subscription_id: Number(formData.test_subscription_id),
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );

      if (response.data.success === true) {
        showToast.success("Configuration saved successfully!");
        setFormData({
          test_subscriber_id: "",
          test_service_id: "",
          test_subscription_id: "",
        });
        fetchConfigurations(); // Refresh values after save
      } else {
        showToast.error(response.data.message || "Failed to save configuration.");
      }
    } catch (error) {
      console.error(error);
      showToast.error("An error occurred while saving configuration.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div id="page-container" className="page-header-fixed page-sidebar-fixed fade in">
      <div id="content" className="">
        <CompanyHeader />

        <div className="panel panel-default with-rounded-corner with-shadow mt-3">
          <form onSubmit={handleSubmit} className="stdform">
            <div className="panel-heading border-0">
              <span className="panel-title">Test Notification Configuration</span>
            </div>

            <div className="panel-body">
              <div className="row">
                {/* Subscriber ID */}
                <div className="col-md-4 mb-3">
                  <InputBox
                    label="Subscriber ID"
                    fieldname="test_subscriber_id"
                    value={formData.test_subscriber_id}
                    onChange={handleChange}
                    placeholder="Enter Subscriber ID (comma separated)"
                  />
                </div>

                {/* Subscription ID */}
                <div className="col-md-4 mb-3">
                  <InputBox
                    label="Subscription ID"
                    fieldname="test_subscription_id"
                    value={formData.test_subscription_id}
                    onChange={handleChange}
                    placeholder="Enter Subscription ID"
                  />
                </div>

                {/* Service Dropdown */}
                <div className="col-md-4 mb-3">
                  <label className="form-label fw-bold">Select Service</label>
                  <select
                    name="test_service_id"
                    className="form-control"
                    value={formData.test_service_id}
                    onChange={handleChange}
                  >
                    <option value="">-- Select Service --</option>
                    {serviceList.map((service) => (
                      <option key={service.id} value={service.id}>
                        {service.service_name}
                      </option>
                    ))}
                  </select>
                </div>
              </div>

              <div className="clearfix"></div>

              <SubmitButton
                pageBack="/Settings/Company"
                handleSubmit={handleSubmit}
                loading={loading}
              />
            </div>
          </form>
        </div>

        {/* Scroll to Top */}
        <Link to="#" data-click="scroll-top" className="btn-scroll-top fade">
          <i className="ti-arrow-up"></i>
        </Link>
      </div>
    </div>
  );
};

export default TestNotification;
